
//So here logic is that when agent is going to upload  a logo or photo thean its gonna be uploaded as draft and when Lyn customise it and  reuplaod through admin it then it will be uploaded as logo or photo

import moment from "moment";

//In start both keys will be null. After agent uploads it will be uploaded as draft and when admin uploads it will be uploaded as logo or photo. When admin uploads than it will set draft keys to null and logo and photo keys will be set to the uploaded image

function getOnePhotoForProfile(agentData){
  const {photoURL, draftPhotoURL} = agentData;

  return (draftPhotoURL ? draftPhotoURL : photoURL) || null;
}

function isAnyAgentLogoAdded(agentData = {}) {
  //Check for both draftLogoURL and logoURL. One of them should be present
  return (agentData.draftLogoURL && agentData.draftLogoURL !== "") || (agentData.logoURL && agentData.logoURL !== "");
};

function isAnyAgentPhotoAdded(agentData = {}) {
  //Check for both draftPhotoURL and photoURL. One of them should be present
  return (agentData.draftPhotoURL && agentData.draftPhotoURL !== "") || (agentData.photoURL && agentData.photoURL !== "");
};

function handleAgentPhotoLogoKeys(agentData, uploadedByAdmin, currentMediaUrl = null, type = 'photo') {
  /**
   * If "uploadedByAdmin" is false in "uploadAgentPhoto", then "draftPhotoURL" and "draftPhotoURLUploadDate" is set and "photoURL" and "photoURLUploadDate" wont be touched
if "uploadedByAdmin" is true in "uploadAgentPhoto", then "photoURL" and "photoURLUploadDate" is set and the draft values are reset.
   */
  const currentDateTime = moment(new Date()).format("YYYY-MM-DD hh:mm A");
  if(type === 'photo'){
    if(!uploadedByAdmin){
      return {
        ...agentData,
        draftPhotoURL: currentMediaUrl,
        draftPhotoURLUploadDate: currentDateTime
      }
    }else{
      return {
        ...agentData,
        photoURL: currentMediaUrl,
        photoURLUploadDate: currentDateTime,
        draftPhotoURL: null,
        draftPhotoURLUploadDate: null
      }
    }
  } else if(type === 'logo'){
    if(!uploadedByAdmin){
      return {
        ...agentData,
        draftLogoURL: currentMediaUrl,
        draftLogoURLUploadDate: currentDateTime
      }
    }else{
      return {
        ...agentData,
        logoURL: currentMediaUrl,
        logoURLUploadDate: currentDateTime,
        draftLogoURL: null,
        draftLogoURLUploadDate: null
      }
    }
  } else{
    return agentData;
  }
}

export { isAnyAgentLogoAdded, isAnyAgentPhotoAdded, getOnePhotoForProfile, handleAgentPhotoLogoKeys };
